import {
  MessagePrimitiveAttachments,
  MessagePrimitiveAttachmentByIndex,
} from "@assistant-ui/core/react";

export type MessageAttachmentsProps = MessagePrimitiveAttachments.Props;

export type MessageAttachmentByIndexProps =
  MessagePrimitiveAttachmentByIndex.Props;

export const MessageAttachmentByIndex = MessagePrimitiveAttachmentByIndex;

export const MessageAttachments = MessagePrimitiveAttachments;
